<template>
  <div class="home">
    <div class="pirate pirate_public">
      <div class="p1">
        <img src="../../images/t1/header.png" alt="" class="header_img" />
        <img src="../../images/t1/header_sp.png" alt="" class="header_img_m" />
      </div>
      <div class="p2">
        <img src="../../images/p2/h2.png" alt="" class="title fadein" />
        <div class="title_m fadein">
          <img
            src="../../images/mobile/top_icon.png"
            alt=""
            class="title_icon"
          />
        </div>
        <div class="content_text fadein">
          <div class="desc_wrapper">
            <a
              href="https://www.youtube.com/watch?v=nP9XCa4ffbc"
              target="_blank"
              class="link"
            ></a>
            <img src="../../images/p2/desc.png" alt="" class="desc" />
          </div>
        </div>
        <!-- <img src="../../images/p2/desc.png" alt="" class="content fadein" /> -->
        <div class="content_m_wrapper fadein">
          <a
            class="link_m"
            href="https://www.youtube.com/watch?v=nP9XCa4ffbc"
            target="_blank"
          ></a>
          <img
            src="../../images/mobile/top_desc.png"
            alt=""
            class="content_m"
          />
        </div>
      </div>
      <div class="p3">
        <img src="../../images/green/text2.png" alt="" class="p_title fadein" />
        <div class="list_wrapper">
          <img src="../../images/p3/t2.png" alt="" class="list_title fadein" />
          <div class="list fadein">
            <img class="list_item" src="../../images/p3/r2.png" alt="" />
          </div>
        </div>
        <div class="list_wrapper">
          <img src="../../images/p3/t3.png" alt="" class="list_title fadein" />
          <div class="list fadein">
            <img class="list_item" src="../../images/p3/r3.png" alt="" />
          </div>
        </div>
        <div class="list_wrapper">
          <img src="../../images/p3/t4.png" alt="" class="list_title fadein" />
          <div class="list fadein">
            <img class="list_item" src="../../images/p3/r4.png" alt="" />
          </div>
        </div>
        <div class="list_wrapper">
          <img src="../../images/p3/t1.png" alt="" class="list_title fadein" />
          <div class="list fadein">
            <img class="list_item" src="../../images/p3/r1.png" alt="" />
          </div>
        </div>
      </div>
      <div class="p4">
        <div class="p4_content">
          <div class="p_row">
            <div class="title fadein">開催日程</div>
            <img
              src="../../images/p5/date.png"
              alt=""
              class="desc_img fadein"
            />
          </div>
          <div class="p_row">
            <div class="title fadein">実況・解説</div>
            <div class="guide_list">
              <img
                src="../../images/p5/r3.png"
                alt=""
                class="guide_item fadein"
              />

              <img
                src="../../images/p5/r2.png"
                alt=""
                class="guide_item fadein"
              />
              <img
                src="../../images/p5/r1.png"
                alt=""
                class="guide_item fadein"
              />
            </div>
          </div>
          <div class="p_row">
            <div class="title fadein">配信チャンネル</div>
            <a
              href="https://www.youtube.com/channel/UC8Wn_3U-fssptm6US_nsoOA"
              target="_blank"
              class="info_wrapper"
            >
              <img
                src="../../images/p3/p_red.png"
                alt=""
                class="info3 fadein"
              />
            </a>
          </div>
        </div>
      </div>
      <footer class="foot_area">
        <div class="container">
          <div class="icon_area">
            <img src="../../images/other/logo.png" alt="" class="yo" />
            <img src="../../images/other/dog.png" alt="" class="cat" />
          </div>
          <div class="link_area">
            <a href="https://mahjongsoul.com/terms_of_service" class="desc">
              利用規約
            </a>
            <a href="https://mahjongsoul.com/privacy_policy" class="desc"
              >プライバシーポリシー</a
            >
            <a href="https://mahjongsoul.com/money_settlement" class="desc">
              資金商取引法に基づく表示 </a
            ><br />
            <a href="https://mahjongsoul.com/specific_business" class="desc"
              >特定商取引法に基づく表示</a
            >
          </div>
          <div class="bottom_desc">
            ©2019 Soul Games, Inc.©ANYCOLOR, Inc.©2019 Yostar, Inc.
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
export default {
  name: 'homePage',
  mounted() {
    window.scrollTo(0, 1);
    this.$nextTick(() => {
      $(window).scroll(function () {
        $('.fadein').each(function () {
          var elemPos = $(this).offset().top;
          var scroll = $(window).scrollTop();
          var windowHeight = $(window).height();
          if (scroll > elemPos - windowHeight + 100) {
            $(this).addClass('scrollin');
          } else {
            $(this).removeClass('scrollin');
          }
        });
      });
    });
  },
};
</script>

<style lang="less" scoped>
.home {
  .pirate_public {
    position: relative;
  }

  .pirate {
    display: flex;
    flex-direction: column;
    background: url('../../images/t1/tbg.png') no-repeat;
    background-size: cover;
    background-attachment: fixed;
    min-height: 100vh;
    width: 100%;

    .p1 {
      box-sizing: border-box;
      position: relative;
      width: 100%;
      padding-top: 56.26%;
      display: flex;
      align-items: center;

      .header_img {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
      }

      .header_img_m {
        display: none;
      }
    }

    .p2 {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 100%;
      // height: 28.82rem;
      height: 30.82rem;
      background-color: rgba(255, 255, 255, 0.35);
      .title {
        // margin-top: 2rem;
        display: flex;
        width: 34.92rem;
      }
      .title_m {
        display: none;
      }

      .content_text {
        margin: 0 auto;
        margin-top: 2rem;
        // width: 63.83vw;
        display: flex;
        align-items: center;
        width: 63.83vw;
        // height: 11.42vw;
        // height: 15.42vw;
        flex-direction: column;
        .desc_wrapper {
          position: relative;
          width: 29.46rem;
          height: 7.94rem;
          .desc {
            width: 29.46rem;
            height: 7.94rem;
          }
          .link {
            position: absolute;
            display: inline-block;
            top: 3.53rem;
            left: 1.61rem;
            height: 0.92rem;
            width: 11.38rem;
          }
        }
      }

      .content_m_wrapper {
        display: none;
      }
    }

    .p3 {
      display: flex;
      flex-direction: column;
      align-items: center;

      .p_title {
        margin-top: 2.76rem;
        width: 16.63rem;
        margin-bottom: 2.71rem;
      }

      .list_wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 2.8rem;

        .list_title {
          height: 2.15rem;
        }

        .list {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          .list_item {
            margin-top: 1.37rem;
            width: 26rem;
          }
        }
      }
    }

    .p4 {
      background-color: rgba(255, 255, 255, 0.35);
      padding-bottom: 6rem;
      display: flex;
      justify-content: center;
      .p4_content {
        width: 25rem;
        .p_row {
          margin-top: 3.35rem;
          display: flex;
          flex-direction: column;
          &:first-child {
            margin-top: 1.5rem;
          }
          .title {
            align-self: flex-start;
            padding: 0 1.38rem;
            font-family: OedKtrStd;
            font-size: 1.15rem;
            display: flex;
            align-items: center;
            line-height: 1.15rem;
            height: 2rem;
            background: #2cb2bb;
            border: 0.15rem solid #ffffff;
            border-radius: 0.38rem;
            color: #ffffff;
            text-shadow: 0px 0px 1rem #19779b;
          }
          .guide_list {
            display: flex;
            align-items: flex-start;
            margin-left: 1.22rem;
            margin-top: 1.28rem;
            .guide_item {
              width: 7.22rem;
              margin-right: 0.77rem;
            }
          }
          .desc_img {
            margin-top: 0.8rem;
            width: 10.76rem;
          }
          .info2 {
            margin-top: 0.5rem;
            width: 26.8rem;
          }
          .info3 {
            margin-top: 1rem;
            margin-left: 1rem;
            width: 23.42rem;
          }
        }
      }
    }

    .p5 {
      display: flex;
      flex-direction: column;
      align-items: center;

      .p_title {
        margin-top: 2.8rem;
        width: 15.76rem;
      }

      .content_wrapper {
        display: flex;
        margin-bottom: 2.53rem;
        margin-top: 2.58rem;

        .content_box {
          width: 23.68rem;
          height: 7.55rem;
        }
      }
    }

    .p6 {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      height: 43.58rem;
      background: url('../../images/p5/bg.png') no-repeat;
      background-size: cover;

      .p_title {
        margin-top: 3.21rem;
        width: 6.71rem;
      }

      .list {
        margin-top: 2.76rem;
        height: 31.45rem;
        font-size: 1.08rem;
        font-family: SeuratPro-B;
        font-weight: bold;
        color: #141414;
        line-height: 2.17rem;
      }

      .list_phone {
        display: none;
      }
    }

    .foot_area {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 1.53846rem 0 1.53846rem;
      background: #000000;
      font-size: 0;

      .icon_area {
        display: flex;
        align-items: center;
        justify-content: center;

        .yo {
          height: 1.15385rem;
        }

        .cat {
          margin-left: 0.76923rem;
          height: 1.15385rem;
        }
      }

      .link_area {
        margin-top: 1.47rem;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 0.97rem;

        .desc {
          &:hover {
            color: #f5ed00;
          }

          padding: 0.18rem 0.46154rem;
          white-space: nowrap;
          font-size: 0.42308rem;
          font-family: GothicMB101Pr6N;
          font-weight: 400;
          color: #ffffff;
          line-height: 0.42308rem;
          position: relative;

          &::after {
            display: block;
            content: '';
            position: absolute;
            height: 0.56rem;
            width: 1px;
            right: -1px;
            background-color: #fff;
            top: 50%;
            transform: translateY(-0.28rem);
          }

          &:last-child::after {
            display: none;
          }
        }

        .bar {
          margin: 0 0.65rem;
          color: #ffffff;
        }
      }

      .bottom_desc {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        margin-top: 0.57692rem;
        font-size: 0.38462rem;
        font-family: GothicMB101Pr6N;
        font-weight: 400;
        color: #ffffff;
        line-height: 0.55rem;
      }
    }
  }

  @media screen and (max-width: 600px) {
    .pirate {
      background: transparent;
      width: 100vw;
      box-sizing: border-box;
      // background: url('../../images/t1/bg_sp.png') no-repeat;
      .p1 {
        box-sizing: border-box;
        padding-top: 205%;

        .header_img {
          display: none;
        }

        .header_img_m {
          display: inline-block;
          position: absolute;
          top: 0;
          right: 0;
          width: 100%;
        }
      }

      .p2 {
        box-sizing: border-box;
        height: 604px;
        .title {
          margin-top: 0px;
          width: 266px;
          display: none;
        }
        .title_m {
          display: flex;
          position: relative;
          margin-top: 0px;
          width: 266px;
          height: 97px;
          background: url('../../images/mobile/banner_m.png');
          background-size: cover;
          background-position: center;
          .title_icon {
            position: absolute;
            top: -37px;
            right: -24px;
            width: 85px;
            height: 78px;
          }
        }
        .content_text {
          display: none;
          margin-top: 0;
        }
        .content {
          display: none;
          margin-top: 30px;
          width: 354px;
        }
        .content_m_wrapper {
          margin-top: 124px;
          height: 204px;
          display: inline-block;
          position: relative;
          .link_m {
            position: absolute;
            left: 24px;
            top: 54px;
            width: 155px;
            height: 18px;
          }
          .content_m {
            display: inline-block;
            height: 204px;
          }
        }
      }

      .p3 {
        box-sizing: border-box;

        .p_title {
          width: 170px;
        }

        .list_wrapper {
          padding: 0 40px;
          box-sizing: border-box;
          width: 100%;
          .list_title {
            height: 21px;
          }
          .list {
            .list_item {
              width: 268px;
            }
          }
        }
      }
      .p4 {
        display: flex;
        align-items: center;
        .p4_content {
          width: 290px;
          .p_row {
            margin-top: 37px;
            .title {
              display: flex;
              align-items: center;
              padding: 0 8px;
              height: 23px;
              background: #2cb2bb;
              border: 2px solid #ffffff;
              border-radius: 4px;
              font-size: 13px;
              font-family: OedKtrStd;
              color: #ffffff;
              line-height: 12px;
              text-shadow: 0px 0px 5px #19779b;
            }
            .guide_list {
              margin-left: 18px;
              .guide_item {
                width: 82px;
                margin-right: 9px;
              }
            }
            .desc_img {
              width: 122px;
              margin-top: 8px;
            }
            .desc {
            }
            .info2 {
              width: 296px;
              margin-left: 8px;
            }
            .info_wrapper {
              display: flex;
              .info3 {
                margin-left: 13px;
                width: 266px;
              }
            }
          }
        }
      }
      .p5 {
        .content_wrapper {
          display: flex;

          .content_box {
            width: 300px;
          }
        }
      }

      .p6 {
        box-sizing: border-box;
        padding: 0px 20px 42px;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100vw;
        background: url('../../images/p5/bg.png') no-repeat;
        background-size: cover;
        height: auto;

        .p_title {
          margin-top: 3.21rem;
          width: 6.71rem;
        }

        .list {
          display: none;
        }

        .list_phone {
          margin-top: 24px;
          display: block;

          .item {
            display: flex;

            .point {
              flex-shrink: 0;
              margin-right: 8px;
              margin-top: 13px;
              background-color: #000;
              height: 4px;
              width: 4px;
              border-radius: 4px;
            }

            .text {
              font-size: 20px;
              font-family: SeuratPro-B;
              font-weight: bold;
              color: #141414;
              line-height: 30px;
            }
          }
        }
      }

      .foot_area {
        width: 100%;
        padding-top: 26px;
        height: 161px;

        .container {
          position: relative;
          width: auto;
          margin-right: auto;
          margin-left: auto;

          .icon_area {
            margin-top: 0;

            .yo {
              height: 19px;
              width: 80px;
            }

            .cat {
              width: 80px;
              height: 22px;
            }
          }

          .link_area {
            height: auto;
            margin-top: 17px;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            padding: 0 17px;

            .desc {
              white-space: nowrap;
              font-size: 7px;
              font-family: GothicMB101Pr6N;
              font-weight: 400;
              color: #ffffff;
              line-height: 20px;
              padding: 2px 9px;
              white-space: nowrap;
              position: relative;

              &::after {
                display: block;
                content: '';
                position: absolute;
                height: 14px;
                width: 2px;
                right: -1px;
                background-color: #fff;
                top: 50%;
                transform: translateY(-6px);
              }

              &:last-child::after {
                display: none;
              }
            }
          }

          .bottom_desc {
            font-size: 7px;
            font-family: GothicMB101Pr6N;
            font-weight: 400;
            color: #ffffff;
            line-height: px;
            margin-top: 13px;
          }
        }
      }
    }

    .pirate::before {
      content: '';
      background: url('../../images/t1/bg_sp.png') no-repeat;
      position: fixed;
      top: 0;
      left: 0;
      height: 100vh;
      width: 100%;
      background-size: cover;
      z-index: -1;
    }
  }
}

@media screen and (max-width: 600px) {
  body {
    width: auto;
  }
}
</style>
